<template>
  <div>
    <b-form-group label-align="right" :label="$t('Credit')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="number" v-model="newAccount.credit"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('VAT, %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="number" v-model="vatRate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('External ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input v-model="newAccount.external_id"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Sale tax rate')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input v-model="saleTaxRate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Internet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="internet" v-model="newAccount.int_status"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Block')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-select :options="blockType" v-model="newAccount.is_blocked"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Auto enable internet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-checkbox switch size="lg" v-model="newAccount.auto_enable_inet"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Unlimited mode')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-checkbox switch size="lg" v-model="newAccount.unlimited"/>
    </b-form-group>

    <b-row>
      <b-col cols="5">
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col cols="6">
            <md-button @click.stop="hideAddAccount"  >{{ $t('Cancel') }}</md-button>
          </b-col>
          <b-col cols="6">
            <md-button @click.stop="addAccount" class="md-raised">{{ $t('Save') }}</md-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    currentRow: null
  },
  data () {
    return {
      vatRate: 0,
      saleTaxRate: 0,
      internet: [{'text': this.$i18n.t('On'), 'value': 1}, {'text': this.$i18n.t('Off'), 'value': 0}],
      blockType: [{'text': this.$i18n.t('Active'), 'value': false}, {'text': this.$i18n.t('Admin block'), 'value': true}],
      newAccount: {
        'user_id': 0,
        'is_basic': false,
        'is_blocked': false,
        'balance': 0,
        'credit': 0,
        'vat_rate': 0,
        'sale_tax_rate': 0,
        'int_status': 1,
        'unlimited': false,
        'auto_enable_inet': false,
        'external_id': '',
        'contract_number': '',
        'signature_date': 0,
        'contract_close_date': 0
      }
    }
  },
  watch: {
    vatRate: function (Val) {
      this.newAccount.vat_rate = (Number(Val) / 100.0).toFixed(4)
    },
    saleTaxRate: function (Val) {
      this.newAccount.sale_tax_rate = (Number(Val) / 100.0).toFixed(4)
    }
  },
  methods: {
    hideAddAccount () {
      this.$emit('hideAddAccount')
    },
    addAccount () {
      this.newAccount.user_id = this.currentRow.user_id
      this.newAccount.credit = Number(this.newAccount.credit)
      this.newAccount.sale_tax_rate = Number(this.newAccount.sale_tax_rate)
      this.newAccount.vat_rate = Number(this.newAccount.vat_rate)
      let response = this.$store.dispatch('Users/CREATE_ACCOUNT', this.newAccount)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_ACCOUNT_USER', this.currentRow.user_id)
          this.hideAddAccount()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  mounted () {
    let data = this.$store.dispatch('Settings/GET_REGISTRY_SYSTEM_VAT', this.newAccount)
    data.then(data => {
      this.vatRate = Number(data.value) * 100
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accounts/formAdd.vue